// blog data

export const Blogs = [
    {
        id:1,
        name:"How can i use React useFormik with Modals",
        tags:["react","formik"],
        date:"30 Sep, 2021",
        imgSrc:"https://photos.google.com/share/AF1QipNLh-doYSnOSzoOnZ_W_JiTUqATY951D-Lx7AWQH_pMdnTKFjdbOJqZqtPXI6qMIQ/photo/AF1QipM7pfKXSckrJMP4Mq_SyFIFvQBnTbDuFhP6TtG8?key=RkFsNjVlQTEyRTd5X3loTVhVcXowWmJDcXoxcU5R",
        link:"https://medium.com/@umacgamze49/how-can-i-use-react-useformik-with-modals-54e0f229dbbe"
    },
    {
        id:2,
        name:"Axios or fetch? What is the difference?",
        tags:["react","node-fetch"],
        date:"8 Oct, 2021",
        imgSrc:"https://photos.google.com/share/AF1QipNLh-doYSnOSzoOnZ_W_JiTUqATY951D-Lx7AWQH_pMdnTKFjdbOJqZqtPXI6qMIQ/photo/AF1QipPDrNKmVZTlaQM5IDm6xP4qZgGklCOOmJ2S7DD2?key=RkFsNjVlQTEyRTd5X3loTVhVcXowWmJDcXoxcU5R",
        link:"https://medium.com/@umacgamze49/axios-or-fetch-what-is-the-difference-e7c727f4f0a8"
    },
    {
        id:3,
        name:"About Kubernetes and Docker",
        tags:["kubernetes","docker"],
        date:"6 July, 2021",
        imgSrc:"https://photos.google.com/share/AF1QipNLh-doYSnOSzoOnZ_W_JiTUqATY951D-Lx7AWQH_pMdnTKFjdbOJqZqtPXI6qMIQ/photo/AF1QipOv4ONldfMRXWbDjo6cNK9iOY7r5eHm9GpaBQQA?key=RkFsNjVlQTEyRTd5X3loTVhVcXowWmJDcXoxcU5R",
        link:"https://medium.com/@umacgamze49/about-kubernetes-and-docker-f2331556ec71"
    },
    {
        id:4,
        name:"JWM, JRE AND JDK",
        tags:["java","Java Runtime Environment"],
        date:"7 Nov, 2021",
        imgSrc:"https://photos.google.com/share/AF1QipNLh-doYSnOSzoOnZ_W_JiTUqATY951D-Lx7AWQH_pMdnTKFjdbOJqZqtPXI6qMIQ/photo/AF1QipN1dn7Ixddz8rcR_G34i8ZJook-tUrgjouIr7i7?key=RkFsNjVlQTEyRTd5X3loTVhVcXowWmJDcXoxcU5R",
        link:"https://medium.com/@umacgamze49/jwm-jre-and-jdk-f93449c97055"
    } 
] 